import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonDirective, WcgDialogModule } from '@wcg/frontend-framework';

@Component({
  selector: 'wcg-contact-us-dialog',
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.scss'],
  imports: [WcgDialogModule, MatButtonModule, ButtonDirective],
})
export class ContactUsDialogComponent {
  private readonly _dialogRef = inject(MatDialogRef<ContactUsDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  handleDone() {
    this._dialogRef.close(true);
  }
}
